import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function AdminRoute({ children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950" data-testid="admin-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-800 border-t-teal-400" />
      </div>
    );
  }

  if (user === null) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;

  return children;
}
